'use client';

import { useTracker } from '@lichtblick/tracker';
import type React from 'react';
import type { PropsWithChildren } from 'react';
import styles from './app-badges.module.scss';

type AppStore = 'Android' | 'IOS';

type AppBadgeProps = PropsWithChildren & {
  appStore: AppStore;
  href: string;
};

const ariaLabelMap: Record<AppStore, string> = {
  Android: 'Im Google Play Store ansehen',
  IOS: 'Im Apple App Store',
};

export const AppBadge: React.FC<AppBadgeProps> = ({ href, appStore, children }) => {
  const { trackCustomEvent } = useTracker();

  const trackEvent = (appStore: AppStore) => {
    trackCustomEvent(
      {
        eventName: 'app_link',
        customProps: {
          link_type: appStore,
        },
      },
      undefined,
      false,
    );
  };

  return (
    <a
      aria-label={ariaLabelMap[appStore]}
      href={href}
      onClick={() => trackEvent(appStore)}
      rel="noopener noreferrer"
      target="_blank"
      className={styles.anchor}
    >
      {children}
    </a>
  );
};
